export default "__VITE_ASSET__a98947a5__"